import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";

import ErrorBoundary from "lib/ErrorBoundary";
import buildStore from "AssortmentOverview/ProductSection/state/productSection";
import { Layout } from "components/Layout";
import { Provider as ApolloProvider } from "lib/Apollo";
import { Provider as LDProvider } from "lib/LaunchDarkly";
import { useAgGridLicense } from "lib/AgGrid";
import { useDatadog } from "lib/Datadog";
import { useHotjar } from "lib/HotJar";
import { useTrackingIdentity } from "lib/Mixpanel";
import { useUserpilot } from "lib/Userpilot";
import { useInitializePendo } from "lib/Pendo";
import AppErrorComponent from "./AppErrorComponent";

const AppIntegrations = () => {
  useAgGridLicense();
  useDatadog();
  useHotjar();
  useTrackingIdentity();
  useUserpilot();
  useInitializePendo();
  return null;
};

const appStore = buildStore();
const App = () => (
  <Router>
    <ReduxProvider store={appStore}>
      <LDProvider>
        <ApolloProvider>
          <ErrorBoundary FallbackComponent={AppErrorComponent}>
            <AppIntegrations />
          </ErrorBoundary>
          <ErrorBoundary FallbackComponent={AppErrorComponent}>
            <Layout />
          </ErrorBoundary>
        </ApolloProvider>
      </LDProvider>
    </ReduxProvider>
  </Router>
);

export default App;
